<script setup lang="ts">
import BrandAvatar from './BrandAvatar.vue';

defineProps<{
    userAvatar?: string | null;
    userName?: string | null;
    clubAvatar?: string | null;
    clubName: string;
}>();
</script>

<template>
    <div class="link-wrap" aria-hidden="true">
        <div class="link-stage">
            <BrandAvatar :src="userAvatar" :name="userName" size="lg" />
            <div class="link-mark">
                <svg viewBox="0 0 24 24" fill="none">
                    <path
                        d="M6 12h12m-4-4 4 4-4 4"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
            <BrandAvatar :src="clubAvatar" :name="clubName" size="lg" />
        </div>
    </div>
</template>

<style scoped>
.link-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 9px;
    padding: 2px 0 4px;
}
.link-stage {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
}
.link-stage :deep(.brand-avatar) {
    width: 86px;
    height: 86px;
    border-radius: 50%;
    border: 3px solid var(--surface);
    box-shadow: 0 12px 30px rgba(12, 26, 48, 0.15);
}
.link-stage :deep(.brand-avatar:first-child) {
    animation: user-avatar-float 4.8s ease-in-out infinite;
}
.link-stage :deep(.brand-avatar:last-child) {
    animation: club-avatar-float 4.8s ease-in-out infinite;
}
.link-mark {
    position: relative;
    z-index: 2;
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    margin: 0 -2px;
    border: 3px solid var(--bg);
    border-radius: 50%;
    background: var(--accent);
    color: white;
    box-shadow: 0 7px 16px color-mix(in srgb, var(--accent) 30%, transparent);
}
.link-mark svg {
    width: 18px;
    height: 18px;
}

@keyframes user-avatar-float {
    0%,
    100% {
        transform: translate(5px, 0) rotate(-3deg);
    }
    50% {
        transform: translate(5px, -3px) rotate(-1deg);
    }
}

@keyframes club-avatar-float {
    0%,
    100% {
        transform: translate(-5px, 0) rotate(3deg);
    }
    50% {
        transform: translate(-5px, 3px) rotate(1deg);
    }
}

@media (prefers-reduced-motion: reduce) {
    .link-stage :deep(.brand-avatar:first-child) {
        animation: none;
        transform: translateX(5px) rotate(-3deg);
    }

    .link-stage :deep(.brand-avatar:last-child) {
        animation: none;
        transform: translateX(-5px) rotate(3deg);
    }
}
</style>
